import "jquery-validation";

(() => {
  const { jQuery: $, window } = globalThis;
  const DelhiZoo = window.DelhiZoo || {};

  DelhiZoo.indexPage = {
    init() {
      this.setupValidation();
      this.bindErrorReset();
    },

    // Hide adult error banner when user starts typing or clicking
    bindErrorReset() {
      $(document).on('keyup click', '.js-adult', () => {
        $('.js-adult-error').addClass('dn');
      });
    },

    setupValidation() {
      $.validator.addMethod("atLeastOneAdult", function() {
        return $('.js-adult')
          .toArray()
          .some(input => Number($(input).val() || 0) > 0);
      }, "At least one adult is required");

      $('.js-new-ticket').validate({
        errorClass: 'error_message',
        ignore: [], // Important: validate hidden fields (.visually-hidden)
        rules: {
          first_name: { required: true },
          mobile_number: {
            required: true,
            number: true,
            minlength: 10,
            maxlength: 10
          },
          email: {
            email: true
          },
          // Apply adult validation to one field (covers all .js-adult inputs)
          entry_fee_adult_foreign_saarc: { atLeastOneAdult: true }
        },
        messages: {
          first_name: { required: "Name is required" },
          mobile_number: { required: "Mobile number is required" },
          entry_fee_adult_foreign_saarc: { atLeastOneAdult: "At least one adult is required" }
        },
        errorPlacement(error, element) {
          const msg = error.text();
          if (msg.includes('adult')) {
            $('.js-adult-error').removeClass('dn');
          } else {
            error.insertAfter(element);
          }
        }
      });
    }
  };

  window.DelhiZoo = DelhiZoo;
  $(document).ready(() => DelhiZoo.indexPage.init());
})();
